import React, { useRef } from 'react';
import styles from './color-picker.module.scss';
import { useColorPicker } from './use-color-picker';
import { DropDownInput } from './dropdown-Input';
import { DropDownMenu } from './dropdown-menu';

type ColorPickerProps = {
  label: string;
  initialColor: string;
  onChange: (color: string) => void;
};

export const ColorDropdown = ({
  label = 'Choose a color',
  onChange,
  initialColor,
}: ColorPickerProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const {
    colors,
    isOpen,
    selected,
    inputValue,
    toggleDropdown,
    handleKeyDown,
    handleSearch,
    handleSelect,
    showColorExample,
  } = useColorPicker({ dropdownRef, initialColor, onChange });

  return (
    <div className={styles.dropdown} ref={dropdownRef}>
      <p className={styles.label}>{label}</p>
      <DropDownInput
        selected={selected}
        showColorExample={showColorExample}
        inputValue={inputValue}
        toggleDropdown={toggleDropdown}
        handleKeyDown={handleKeyDown}
        handleSearch={handleSearch}
      />
      <DropDownMenu
        colors={colors}
        selected={selected}
        handleSelect={handleSelect}
        isOpen={isOpen}
      />
    </div>
  );
};
